import { Injectable } from '@angular/core';
import { HttpHeaders, HttpClient, HttpErrorResponse } from '@angular/common/http';
import { environment } from '@environments/environment';
import { throwError } from 'rxjs';
import { Observable, of } from 'rxjs';
import { catchError, map } from 'rxjs/operators';
import { AppConfig } from 'src/assets/config/config/app-config';

const httpOptions = {
  headers: new HttpHeaders({
    'Content-Type': 'application/json'
  }),
  observe: 'response' as 'body'
};

@Injectable({
  providedIn: 'root'
})
export class UsersAndGroupsService {
  constructor(
    private http: HttpClient,
    private config: AppConfig
  ) { }

  isDjango: boolean = environment.isDjangoAuth

  getGroups() {
    var apiUrl = this.config.getConfig("apiUrl")
    return this.http.get<any>(apiUrl + `/usergroups/user`)
  }

  getGroupsForUser(req: any) {
    var apiUrl = this.config.getConfig("apiUrl")
    var url = apiUrl + `/usersAndGroups/user/groups`
    if (this.isDjango) {
      req = { user_id: req.user }
      url = apiUrl + `/djangoauth/group/user`
    }
    return this.http.post(url, req)
  }

  getAdminGroupName() {
    var apiUrl = this.config.getConfig("apiUrl")
    return this.http.get(apiUrl + `/usergroups/admin`)
  }

  getCategoryUsers(categoryId) {
    var apiUrl = this.config.getConfig("apiUrl")
    return this.http.get<any>(apiUrl + `/categories/` + categoryId + `/users`)
  }

  getAllUsers() {
    var apiUrl = this.config.getConfig("apiUrl")
    var url = apiUrl + `/usersAndGroups/getUsers`
    if (this.isDjango) {
      url = apiUrl + `/djangoauth/user/all`
    }
    return this.http.get<any>(url)
  }

  createUser(req: any): Observable<any> {
    var apiUrl = this.config.getConfig("apiUrl")
    return this.http.post(apiUrl + `/djangoauth/user/create`, req).pipe()
  }

  createGroup(group) {
    var apiUrl = this.config.getConfig("apiUrl")
    return this.http.post<any>(apiUrl + `/usersAndGroups/create`, group).pipe(catchError(this.errorHandler))
  }

  getAllGroups() {
    var apiUrl = this.config.getConfig("apiUrl")

    var url = apiUrl + `/usergroups/all`

    if (this.isDjango) {
      url = apiUrl + `/djangoauth/group/all`
    }
    return this.http.get<any>(url).pipe(catchError(this.errorHandler))
  }

  getAllDjangoGroups() {
    var apiUrl = this.config.getConfig("apiUrl")
    return this.http.get<any>(apiUrl + `/djangoauth/group/all`).pipe(catchError(this.errorHandler))
  }

  getDjangoGroupsforUser(req: any) {
    var apiUrl = this.config.getConfig("apiUrl")
    return this.http.post(apiUrl + `/djangoauth/group/user`, req)
  }

  errorHandler(error: HttpErrorResponse) {
    return throwError(error);
  }
}
